import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { initializeFirebase } from '@perfin/shared';

// ============================================================================
// VITE CHUNK LOADING ERROR HANDLER
// Forces hard reload if cached chunks fail to load after a new deployment
// ============================================================================
const RELOAD_KEY = 'vite_chunk_reload';

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  const hasReloaded = sessionStorage.getItem(RELOAD_KEY);
  if (!hasReloaded) {
    sessionStorage.setItem(RELOAD_KEY, 'true');
    console.warn('[PerFin] Chunk load failed, forcing reload...');
    window.location.reload();
  }
});

// Also catch generic chunk loading errors
window.addEventListener('error', (event) => {
  if (event.message?.includes('Failed to fetch dynamically imported module') ||
    event.message?.includes('Loading chunk') ||
    event.message?.includes('Loading CSS chunk')) {
    const hasReloaded = sessionStorage.getItem(RELOAD_KEY);
    if (!hasReloaded) {
      sessionStorage.setItem(RELOAD_KEY, 'true');
      console.warn('[PerFin] Module load failed, forcing reload...');
      window.location.reload();
    }
  }
});

// Clear reload flag on successful load
window.addEventListener('load', () => {
  sessionStorage.removeItem(RELOAD_KEY);
});

// Initialize Firebase with environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const useEmulator = import.meta.env.VITE_USE_EMULATOR === 'true';

initializeFirebase(firebaseConfig, useEmulator);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
